import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { TopNav } from '../components/layout/TopNav';
import { EBTWICBanner } from '../components/layout/EBTWICBanner';
import { ProductCard } from '../components/product/ProductCard';
import { EBTFilter } from '../components/ui/EBTFilter';
import { mockProducts } from '../data/mockProducts';
export function SearchPage() {
  const [query, setQuery] = useState('');
  const [ebtOnly, setEbtOnly] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const categories = Array.from(new Set(mockProducts.map(p => p.category)));
  const filteredProducts = useMemo(() => {
    return mockProducts.filter(product => {
      const matchesQuery = product.name.toLowerCase().includes(query.toLowerCase()) || product.category.toLowerCase().includes(query.toLowerCase());
      const matchesEbt = ebtOnly ? product.isEBT : true;
      const matchesCategory = selectedCategory ? product.category === selectedCategory : true;
      return matchesQuery && matchesEbt && matchesCategory;
    });
  }, [query, ebtOnly, selectedCategory]);
  return <div className="min-h-screen bg-[#F8F9FA]" data-id="element-370">
      <EBTWICBanner data-id="element-371" />
      <TopNav data-id="element-372" />

      <main className="max-w-7xl mx-auto px-6 py-12" data-id="element-373">
        <div className="mb-8" data-id="element-374">
          <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-375">
            Shop All Products
          </h1>
          <div className="flex flex-col lg:flex-row gap-4" data-id="element-376">
            <div className="flex-grow relative" data-id="element-377">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-378" />
              <input type="text" placeholder="Search for yams, spices, diapers..." value={query} onChange={e => setQuery(e.target.value)} className="w-full bg-white border border-gray-200 rounded-xl py-4 pl-12 pr-4 text-base focus:ring-2 focus:ring-[#D37D29] focus:border-transparent transition-all shadow-sm" data-id="element-379" />
            </div>
            <div className="lg:w-80" data-id="element-380">
              <EBTFilter isEnabled={ebtOnly} onToggle={setEbtOnly} data-id="element-381" />
            </div>
          </div>
        </div>

        <div className="flex gap-3 mb-8 overflow-x-auto pb-2" data-id="element-382">
          <button onClick={() => setSelectedCategory(null)} className={`px-6 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap transition-all ${selectedCategory === null ? 'bg-[#1D3557] text-white shadow-md' : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-200'}`} data-id="element-383">
            All Items
          </button>
          {categories.map(cat => <button key={cat} onClick={() => setSelectedCategory(cat === selectedCategory ? null : cat)} className={`px-6 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap transition-all ${selectedCategory === cat ? 'bg-[#1D3557] text-white shadow-md' : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-200'}`} data-id="element-384">
              {cat}
            </button>)}
        </div>

        <div className="flex items-center justify-between mb-6" data-id="element-385">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-386">
            {filteredProducts.length}{' '}
            {filteredProducts.length === 1 ? 'Product' : 'Products'}
          </h2>
          {(query || ebtOnly || selectedCategory) && <button onClick={() => {
          setQuery('');
          setEbtOnly(false);
          setSelectedCategory(null);
        }} className="text-sm text-[#D37D29] font-semibold hover:underline" data-id="element-387">
              Clear All Filters
            </button>}
        </div>

        {filteredProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-388">
            {filteredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-389" />)}
          </div> : <div className="flex flex-col items-center justify-center py-20 text-center" data-id="element-390">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6 text-4xl" data-id="element-391">
              🔍
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-392">
              No products found
            </h3>
            <p className="text-gray-500 max-w-md mx-auto mb-8" data-id="element-393">
              We couldn't find any items matching your filters. Try adjusting
              your search or turning off the EBT filter.
            </p>
            <button onClick={() => {
          setQuery('');
          setEbtOnly(false);
          setSelectedCategory(null);
        }} className="bg-[#D37D29] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#B86A23] transition-colors" data-id="element-394">
              Show All Products
            </button>
          </div>}
      </main>
    </div>;
}